import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tfgApi from '@/features/dashboard/tfg/api/tfgApi.ts';
import { tfgApiQueryKeys } from '@/features/dashboard/tfg/api/tfgApi.queryKeys.ts';
import { AirportDto } from '@/features/dashboard/tfg/types/AirportDto.ts';

export const getAirportsQueryOptions = (): UseQueryOptions<AirportDto[]> => ({
  queryKey: tfgApiQueryKeys.airports(),
  queryFn: () => tfgApi.getAirports(),
  // Static dictionary — cache for the whole session.
  staleTime: 1000 * 60 * 60 * 24,
});

const useGetAirports = () => {
  return useQuery(getAirportsQueryOptions());
};

export default useGetAirports;
